var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.item.hidden)?_c('el-menu-item',{attrs:{"index":`${_vm.sysPath}/` + _vm.basePath}},[_vm._v(_vm._s(_vm.item.meta.title))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }